<template>
  <div class="attendance-dtl">
    <Header title="课程详情"></Header>
    <div class="detail">
      <h4>{{ detailList.kcjc }}</h4>
      <p>
        <i class="icon1"></i><span>教师：</span><b>{{ detailList.jsxm }}</b>
      </p>
      <p><i class="icon2"></i><span>教室：</span>{{ detailList.jsmc }}</p>
      <p>
        <i class="icon3"></i><span style="min-width:80px;">本课时间：</span
        >{{ detailList.jc }}节，{{ detailList.kssj }} - {{ detailList.jssj }}
      </p>
      <p><i class="icon4"></i><span>教学周：</span>第{{ detailList.kkzc }}周</p>
      <div class="qr-area"  @click="checkQr()" v-if="isqdm ==1 && schoolCode != '12763'"></div>
      <div
        class="qt-area"
        v-if="schoolCode == '14128'"
        @click="checkQt()"
      ></div>
    </div>
    <div class="log-btn">
      <button @click="yjqt()" v-if="schoolCode == '14128'">一键标记早退</button>
      <button @click="yjqd()" >一键到课</button>
      <button @click="ktjl()" v-if="schoolCode == '4152014577'">课堂纪律</button>
    </div>
    <van-tabs v-model="active">
      <van-tab :title="this.dkxq">
        <div>
          <el-table :data="attendanceList" stripe>
            <el-table-column
              prop="studentName"
              label="姓名"
              width="100"
              :sort-method="nameSort"
              sortable
            >
              <template slot-scope="scope">
                <span style="color: #212F6E;">{{ scope.row.studentName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="studentNumber" label="学号" sortable>
              <template slot-scope="scope">
                <span style="color: #212F6E;">{{
                  scope.row.studentNumber
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="attendanceResult"
              label="状态"
              sortable
              :sort-method="statusSort"
            >
              <template slot-scope="scope">
                <div
                  style="display:flex;align-items:center;justify-content: space-between;"
                >
                  <span
                    :style="
                      'font-weight:600;' +
                        'color:' +
                        clacResult(scope.row.attendanceResult)
                    "
                    >{{
                      scope.row.attendanceResult == ""
                        ? "未签到"
                        : scope.row.attendanceResult
                    }}</span
                  >
                  <p class="check-attendance" @click="editCheck(scope.row)"></p>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 二维码 -->
    <van-overlay :show="codeArea" @click="codeArea = false">
      <div class="wrapper" id="qrcode" ref="qrcode"></div>
    </van-overlay>
    <!-- 二维码 -->
    <van-overlay :show="codeArea1" @click="codeArea1 = false">
      <div class="wrapper" id="qtcode" ref="qtcode"></div>
    </van-overlay>
    <van-popup v-model="showKtjl" position="bottom">
      <van-picker
        show-toolbar
        :columns="ktjlColumns"
        @cancel="showKtjl = false"
        @confirm="onConfirmKtjl"
        :item-height="35"
        :default-index="defaultIndex"
      />
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :item-height="35"
        :default-index="defaultIndex"
      />
    </van-popup>

    <van-popup v-model="showPicker_13575" closeable close-icon-position="top-right" position="bottom" :style="{height:'80%'}">
        <van-form  style="margin-top: 25px;">
            <!-- v-model="" -->
          <van-field
            v-model="studentNumber"
            readonly
            name="学号"
            label="学号"
            input-align="right"
            error-message-align="right"
          />
          <van-field
            v-model="studentName"
            readonly
            name="姓名"
            label="姓名"
            input-align="right"
            error-message-align="right"
          />
          <van-field
           v-model="xss"
            readonly
            @click="showPicker_xs=true"
            cilckable
            name="学时/次数"
            label="学时/次数"
            input-align="right"
            error-message-align="right"
          />
          <van-field
           v-model="attendanceResult_new"
            readonly
            @click="showPicker_new=true"
            cilckable
            name="考勤"
            label="考勤"
            input-align="right"
            error-message-align="right"
          />
          <van-field
            v-model="qqyy"
            name="缺勤原因"
            label="缺勤原因"
            input-align="right"
            error-message-align="right"
          />
          <van-popup v-model="showPicker_new" position="bottom" >
            <van-picker
                show-toolbar
                :columns="columns"
                @cancel="showPicker_new = false"
                @confirm="onConfirmNew"
                :item-height="35"
                :default-index="defaultIndex"
            />
            </van-popup>

          <van-popup v-model="showPicker_xs" position="bottom" >
            <van-picker
                show-toolbar
                :columns="xsList"
                @cancel="showPicker_xs = false"
                @confirm="onConfirmXs"
                :item-height="35"
                :default-index="defaultIndex"
            />
            </van-popup>
          <div class="alter-buttonsa">
            <button class="clear" @click="clear">取消</button>
            <button class="confirm"   @click="mySubmit">确定</button>
          </div>
        </van-form>
    </van-popup>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import { Api } from "../../../utils/axios";
import { Dialog } from "vant";
export default {
  data() {
    return {
      detailList: [],
      codeArea: false,
      codeArea1: false,
      active: 1,
      attendanceList: [],
      defaultIndex: 0,
      showPicker: false,
      showPicker_13575: false,
      columns: [],
      idList: [],
      attendanceResult: "",
      showKtjl: false,
      ktjlColumns: [],
      ktjlList: [],
      ktjlResult: "",
      studentId: "",
      week: "",
      qrcodeUrl: "",
      qtcodeUrl: "",
      qdTime: "",
      qtTime: "",
      schoolCode: "",
      qrcodeBaseUrl:"",
      isqdm:1,
      dkxq:"到课详情",

      studentName:'',
      studentNumber:'',
      qqyy:'',
      xss:'',
      showPicker_new:false,
      showPicker_xs:false,
      attendanceResult_new:'',
      attendanceResultCode_new:'',
      xsList: [1,2,3,4,5,6],
    };
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.detailList = JSON.parse(this.$route.query.list);
    this.courseList =
      this.detailList.jx0408id +
      "," +
      this.detailList.xq +
      "," +
      this.detailList.jc +
      "," +
      encodeURIComponent(this.detailList.kcjc) +
      "," +
      encodeURIComponent(this.detailList.jsxm) +
      "," +
      encodeURIComponent(this.detailList.jsmc) +
      "," +
      this.detailList.kssj +
      "," +
      this.detailList.jssj +
      "," +
      this.detailList.kkzc +
      "," +
      encodeURIComponent(this.detailList.jc);
    if(this.schoolCode=='14128'){
        this.courseList =
            this.detailList.jx0408id +
            "*@*" +
            this.detailList.xq +
            "*@*" +
            this.detailList.jc +
            "*@*" +
            encodeURIComponent(this.detailList.kcjc) +
            "*@*" +
            encodeURIComponent(this.detailList.jsxm) +
            "*@*" +
            encodeURIComponent(this.detailList.jsmc) +
            "*@*" +
            this.detailList.kssj +
            "*@*" +
            this.detailList.jssj +
            "*@*" +
            this.detailList.kkzc +
            "*@*" +
            encodeURIComponent(this.detailList.jc);
    }
    this.week = this.$route.query.week;
    this.getList();

    this.getStatus();
    this.getKtjl();
  },
  mounted() {},
  methods: {
    nameSort(obj1, obj2) {
      let val1 = obj1.studentName.substring(0, 1);
      let val2 = obj2.studentName.substring(0, 1);
      return val1.localeCompare(val2);
    },
    statusSort(obj1, obj2) {
      let val1 = obj1.attendanceResult.substring(0, 1);
      let val2 = obj2.attendanceResult.substring(0, 1);
      return val1.localeCompare(val2);
    },
    getQrCode() {
      let schoolCode = sessionStorage.getItem("schoolCode");
      this.qdTime=	new Date().getTime();
      //console.log(this.qrcodeBaseUrl+"/checkWorkAttendance/toqd?&week="+this.week+"&isdqrq="+this.$route.query.isdqrq+"&type=qd&time="+this.qdTime+"&jx0408id="+this.detailList.jx0408id,)
      if(schoolCode=='12928'){
        // let url_other = "http://auth.chaoxing.com/connect/oauth2/authorize?appid=fe1597fdd08d4a19b4ba53784d023bd2&redirect_uri=";
        // let url_mine =  this.qrcodeBaseUrl+"/checkWorkAttendance/toAttendanceViwe?course="+this.courseList+"&week="+this.week+"&isdqrq="+this.$route.query.isdqrq+"&type=qd&time="+this.qdTime+"&schoolCode="+schoolCode;

        //let url_mine = this.qrcodeUrl+"/index.html#/student/attendance?course="+this.courseList+"&week="+this.week+"&isdqrq="+this.$route.query.isdqrq+"&type=qd&time="+this.qdTime+"&schoolCode="+schoolCode;
        // let parm_other = "&appId=fe1597fdd08d4a19b4ba53784d023bd2&appKey=yS38m0bMYS37nPfL&fidEnc=b807e0d034749a56&mappId=6395504&formid=&topMenu=";
        // let url = url_other+(encodeURIComponent(url_mine+parm_other))+"&response_type=code&scope=snsapi_base&state=170642";
         let qrcode = new QRCode("qrcode", {
        width: 250,
        height: 250,
        text:this.qrcodeBaseUrl+"/checkWorkAttendance/toqd?&week="+this.week+"&isdqrq="+this.$route.query.isdqrq+"&type=qd&time="+this.qdTime+"&jx0408id="+this.detailList.jx0408id,
        correctLevel: QRCode.CorrectLevel.Q
      });
      }
      else if(schoolCode=='14128'){
          let qrcode = new QRCode("qrcode", {
              width: 250,
              height: 250,
              text:
                  this.qrcodeBaseUrl +
                  "/loginCqcjzyxy?kq=1&course=" +
                  this.courseList +
                  "&week=" +
                  this.week +
                  "&isdqrq=" +
                  this.$route.query.isdqrq +
                  "&type=qd" +
                  "&time=" +
                  this.qdTime +
                  "&schoolCode=" +
                  schoolCode+"&jx0408id="+this.detailList.jx0408id,
              // colorDark : "#000000",
              // colorLight : "#ffffff",
              correctLevel: QRCode.CorrectLevel.Q
          });
      }
      else{
      //   let qrcode = new QRCode("qrcode", {
      //   width: 250,
      //   height: 250,
      //   text:
      //     this.qrcodeUrl +
      //     "/index.html#/student/attendance?course=" +
      //     this.courseList +
      //     "&week=" +
      //     this.week +
      //     "&isdqrq=" +
      //     this.$route.query.isdqrq +
      //     "&type=qd" +
      //     "&time=" +
      //     this.qdTime +
      //     "&schoolCode=" +
      //     schoolCode,
      //   // colorDark : "#000000",
      //   // colorLight : "#ffffff",
      //   correctLevel: QRCode.CorrectLevel.Q
      // });
      //console.log("http://192.168.151.78:8081/bzb_njwhd/checkWorkAttendance/toqd?&week="+this.week+"&isdqrq="+this.$route.query.isdqrq+"&type=qd&time="+this.qdTime+"&jx0408id="+this.detailList.jx0408id)
          let qrcode = new QRCode("qrcode", {
              width: 250,
              height: 250,
              text:this.qrcodeBaseUrl+"/checkWorkAttendance/toqd?&week="+this.week+"&isdqrq="+this.$route.query.isdqrq+"&type=qd&time="+this.qdTime+"&jx0408id="+this.detailList.jx0408id,
              correctLevel: QRCode.CorrectLevel.Q
          });
      //    console.log(
      //   this.qrcodeUrl +
      //     "/index.html#/student/attendance?course=" +
      //     this.courseList +
      //     "&week=" +
      //     this.week +
      //     "&isdqrq=" +
      //     this.$route.query.isdqrq +
      //     "&type=qd" +
      //     "&time=" +
      //     this.qdTime +
      //     "&schoolCode=" +
      //     schoolCode
      // );
      }
    },
    getQtCode() {
        let schoolCode = sessionStorage.getItem("schoolCode");
        if(schoolCode=='14128'){
            let qrcode = new QRCode("qtcode", {
                width: 250,
                height: 250,
                text:
                    this.qrcodeBaseUrl +
                    "/loginCqcjzyxy?kq=1&course=" +
                    this.courseList +
                    "&week=" +
                    this.week +
                    "&isdqrq=" +
                    this.$route.query.isdqrq +
                    "&type=qt" +
                    "&time=" +
                    this.qtTime+"&schoolCode=" +
                    schoolCode+"&jx0408id="+this.detailList.jx0408id,
                // colorDark : "#000000",
                // colorLight : "#ffffff",
                correctLevel: QRCode.CorrectLevel.Q
            });
        }else{
            let qrcode = new QRCode("qtcode", {
                width: 250,
                height: 250,
                text:
                    this.qtcodeUrl +
                    "/index.html#/student/attendance?course=" +
                    this.courseList +
                    "&week=" +
                    this.week +
                    "&isdqrq=" +
                    this.$route.query.isdqrq +
                    "&type=qt" +
                    "&time=" +
                    this.qtTime+"&jx0408id="+this.detailList.jx0408id,
                // colorDark : "#000000",
                // colorLight : "#ffffff",
                correctLevel: QRCode.CorrectLevel.Q
            });
        }
      console.log(qtcode);
    },
    editCheck(e) {
        if(this.schoolCode == "13575"){
            console.log(e);
            this.studentName = e.studentName;
            this.studentNumber = e.studentNumber;
            this.qqyy = e.qqyy
            this.xss = e.xss
            if(e.attendanceResult){
                this.attendanceResult_new = e.attendanceResult;
                this.attendanceResultCode_new = e.attendanceResultCode;
            }else{
                this.attendanceResult_new = "到课";
                this.attendanceResultCode_new = "11";
            }

            this.showPicker_13575 = true;
        }else{
            this.showPicker = true;
        }
      this.studentId = e.studentId;
    },
    async onConfirm(e, i) {
      this.showPicker = false;
      this.attendanceResult = this.idList[i];
      const params = {
        jx0408id: this.detailList.jx0408id,
        zc: this.week,
        xq: this.detailList.xq,
        jc: this.detailList.jc,
        attendanceResult: this.attendanceResult,
        studentId: this.studentId
      };
      const res = await Api.checkWorkAttendanceSaveXskq(params);
      if (res.code == "0") {
        this.$toast.fail(res.Msg);
      } else {
        this.$toast.success(res.Msg);
        if (sessionStorage.getItem("schoolCode") == "14128") {
          this.getList_14128();
        } else {
          this.getList();
        }
      }
    },
    async onConfirmNew(e, i) {
      this.showPicker_new = false;
      console.log(e,i);
      this.attendanceResult_new = e;
      this.attendanceResultCode_new = this.idList[i];;
    },
    async onConfirmXs(e, i) {
      this.showPicker_xs = false;
      console.log(e,i);
      this.xss = e;
    },
    clacResult(e) {
      if (e == "正常" || e == "到课") {
        return "#12DDD6";
      } else if (e == "旷课") {
        return "#F86969";
      } else {
        return "@attendance-color-1";
      }
    },
    async mySubmit(){
        const params = {
        jx0408id: this.detailList.jx0408id,
        zc: this.week,
        xq: this.detailList.xq,
        jc: this.detailList.jc,
        attendanceResult: this.attendanceResult_new,
        attendanceResultCode: this.attendanceResultCode_new,
        studentId: this.studentId,
        qqyy: this.qqyy,
        xss: this.xss
      };
      console.log(params);
      const res = await Api.checkWorkAttendanceSaveXskq(params);

      if (res.code == "0") {
        this.$toast.fail(res.Msg);
      } else {
        this.$toast.success(res.Msg);
        this.showPicker_13575 = false;
        this.getList();
      }
    },
    clear(){
        this.showPicker_13575 = false;
    },
    async getList() {
      const params = {
        jx0408id: this.detailList.jx0408id,
        zc: this.week,
        xq: this.detailList.xq,
        jc: this.detailList.jc
      };
      const res = await Api.checkWorkAttendanceGetKqxs(params);
      if(this.schoolCode=='14128'){
          this.dkxq="到课详情(应到"+res.data.length+"人/实到"+res.yqdrs+"人)"
      }
      this.attendanceList = res.data;
      this.qrcodeUrl = res.foreUrl;
      this.qrcodeBaseUrl = res.baseUrl;
      this.$nextTick(function() {
        document.querySelector("#qrcode").innerHTML = "";
        this.getQrCode();
      });
    },
    async getList_14128() {
      this.qdTime = new Date().getTime();
      const params = {
        jx0408id: this.detailList.jx0408id,
        zc: this.week,
        xq: this.detailList.xq,
        jc: this.detailList.jc,
        type: "qd",
        time: this.qdTime
      };
      const res = await Api.checkWorkAttendanceGetKqxs(params);
      this.attendanceList = res.data;
      if(this.schoolCode=='14128'){
          this.dkxq="到课详情(应到"+res.data.length+"人/实到"+res.yqdrs+"人)"
      }
      this.qrcodeUrl = res.foreUrl;
      this.$nextTick(function() {
        document.querySelector("#qrcode").innerHTML = "";
        this.getQrCode();
      });
    },
    async getList_14128_qt() {
      this.qtTime = new Date().getTime();
      const params = {
        jx0408id: this.detailList.jx0408id,
        zc: this.week,
        xq: this.detailList.xq,
        jc: this.detailList.jc,
        type: "qt",
        time: this.qtTime
      };
      const res = await Api.checkWorkAttendanceGetKqxs(params);
      if(this.schoolCode=='14128'){
          this.dkxq="到课详情(应到"+res.data.length+"人/实到"+res.yqdrs+"人)"
      }
      this.attendanceList = res.data;
      this.qtcodeUrl = res.foreUrl;
      this.$nextTick(function() {
        document.querySelector("#qtcode").innerHTML = "";
        this.getQtCode();
      });
    },
    async getStatus() {
      const res = await Api.checkWorkAttendanceZzdkqbj();
      res.data.forEach((item, index) => {
        this.columns[index] = item.dmmc;
        this.idList[index] = item.dm;
      });
      this.isqdm=res.isqdm;
    },
    checkQr() {
      this.codeArea = true;
        if(this.schoolCode=='14128'){
            this.getList_14128();
        }
        else{
            this.getList();
        }

      setTimeout(() => {
        this.codeArea = true;
      }, 500);

        if(this.schoolCode=='12928' || this.schoolCode=='13766'){
            clearInterval(this.timer)
            this.timer=setInterval(()=>{
                document.querySelector("#qrcode").innerHTML = "";
                this.getQrCode();
            },60*1000);
        } else if(this.schoolCode=='4152014577') {
          clearInterval(this.timer)
          this.timer=setInterval(()=>{
            document.querySelector("#qrcode").innerHTML = "";
            this.getQrCode();
          },60 * 5*1000);
        }
    },
    checkQt() {
      this.getList_14128_qt();
      setTimeout(() => {
        this.codeArea1 = true;
      }, 500);
    },
    yjqt(){
          Dialog.confirm({
              message: "是否将已签到但未签退的学生标记为早退?"
          }).then(() => {
              const params = {
                  jx0408id: this.detailList.jx0408id,
                  zc: this.week,
                  xq: this.detailList.xq,
                  jc: this.detailList.jc,
                  isyjqt:"1"
              };
              const res = Api.checkWorkAttendanceSaveXskq(params);
              res.then((result)=>{
                  if (result.code == "0") {
                      this.$toast.fail(result.Msg);
                  } else {
                      this.$toast.success(result.Msg);
                      setTimeout(() => {
                          if (sessionStorage.getItem("schoolCode") == "14128") {
                              this.getList_14128();
                          } else {
                              this.getList();
                          }
                      }, 1500);
                  }
              })

          }).catch(() => {});
      },
    yjqd(){
          Dialog.confirm({
              message: "是否将所有未签到的学生标记为到课?"
          }).then(() => {
              const params = {
                  jx0408id: this.detailList.jx0408id,
                  zc: this.week,
                  xq: this.detailList.xq,
                  jc: this.detailList.jc,
                  isyjqd:"1"
              };
              const res = Api.checkWorkAttendanceSaveXskq(params);
              res.then((result)=>{
                  if (result.code == "0") {
                      this.$toast.fail(result.Msg);
                  } else {
                      this.$toast.success(result.Msg);
                      setTimeout(() => {
                          if (sessionStorage.getItem("schoolCode") == "14128") {
                              this.getList_14128();
                          } else {
                              this.getList();
                          }
                      }, 1500);
                  }
              })

          }).catch(() => {});
  },
    ktjl(){
      this.showKtjl = true;
    },
    async getKtjl() {
      const res = await Api.checkWorkAttendanceZzdktjl();
      res.data.forEach((item, index) => {
        this.ktjlColumns[index] = item.dmmc;
        this.ktjlList[index] = item.dm;
      });
    },
    async onConfirmKtjl(e, i) {
      this.showKtjl = false;
      this.ktjlResult = this.ktjlList[i];
      const params = {
        jx0408id: this.detailList.jx0408id,
        zc: this.week,
        xq: this.detailList.xq,
        jc: this.detailList.jc,
        ktjl: this.ktjlResult,
        studentId: this.studentId
      };
      const res = await Api.checkWorkAttendanceSaveKtjl(params);
      if (res.code == "0") {
        this.$toast.fail(res.Msg);
      } else {
        this.$toast.success(res.Msg);
      }
    },
  }
};
</script>
<style lang="less" scoped>
.detail {
  padding: 8px 20px;
  color: @attendance-color-1;
  position: relative;
}
.qr-area {
  position: absolute;
  width: 100px;
  height: 49px;
  background: url(../../../../static/img/qr_code.png) no-repeat center;
  background-size: 100%;
  right: 16px;
  top: 51px;
}
.qt-area {
  position: absolute;
  width: 100px;
  height: 49px;
  background: url(../../../../static/img/qt_code.png) no-repeat center;
  background-size: 100%;
  right: 16px;
  top: 100px;
}
.detail > h4 {
  font-size: 24px;
  margin-bottom: 21px;
  width: fit-content;
  position: relative;
}
.detail > h4::after {
  height: 11px;
  content: "";
  position: absolute;
  background-color: #b5b1f4;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: -1;
}
.detail > p {
  display: flex;
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 23px;
}
.detail > p > span {
  font-weight: 400;
  color: @attendance-color-2;
  flex-wrap: nowrap;
}
.detail > p > b {
  max-width: calc(~"100% - 180px");
}
.detail i {
  width: 22px;
  height: 23px;
  margin-right: 8px;
}
.detail i.icon1 {
  background: url(../../../assets/images/icon_people2.png) no-repeat center;
  background-size: 22px 23px;
}
.detail i.icon2 {
  background: url(../../../assets/images/address_icon2.png) no-repeat center;
  background-size: 22px 23px;
}
.detail i.icon3 {
  background: url(../../../assets/images/time_icon2.png) no-repeat center;
  background-size: 22px 23px;
}
.detail i.icon4 {
  background: url(../../../assets/images/date_icon2.png) no-repeat center;
  background-size: 22px 23px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.wrapper > img {
  padding: 10px;
  background-color: #ffffff;
}
.check-attendance {
  background: url(../../../../static/img/edit.png) no-repeat center;
  width: 16px;
  height: 16px;
  background-size: 100%;
}
.attendance-dtl .van-popup.van-popup--bottom {
  border-radius: 5px 5px 0 0;
} /* box-shadow:0px -2px 2px 0px rgba(223,223,223,0.5); */
.attendance-dtl .van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}

.attendance-dtl .van-picker__cancel {
  color: rgba(0, 0, 0, 0);
  background: url(../../../../static/img/close.png) no-repeat center;
  position: absolute;
  background-size: 25px 25px;
  width: 25px;
  height: 25px;
  left: 0;
  margin: 10px;
}
.attendance-dtl .van-picker__confirm {
  color: rgba(0, 0, 0, 0);
  background: url(../../../../static/img/confirm.png) no-repeat center;
  position: absolute;
  background-size: 25px 25px;
  width: 25px;
  height: 25px;
  right: 0;
  margin: 10px;
}
.attendance-dtl .van-picker__columns::before {
  width: 120px;
  height: 1px;
  background-color: #dfe0e6;
  content: "";
  position: absolute;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);
}
.attendance-dtl .van-picker__columns::after {
  width: 120px;
  height: 1px;
  background-color: #dfe0e6;
  content: "";
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
}
.attendance-dtl
  .van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
  color: @attendance-color-1;
  font-weight: 600;
}
.log-btn {
  text-align: center;
  padding: 0 1.25rem;
  button {
    background-color: @attendance-background-color-1;
    padding: 11px 0;
    width: 100%;
    color: @attendance-color-3;
    border-radius: 3px;
    margin-top: 10px;
    margin-bottom:5px;
  }
}
.alter-buttonsa{
    z-index: 9;
    background-color: @attendance-color-3;
    display: flex;justify-content: space-between;align-items: center;
    button{
      width: calc(~"50% - 10px");padding: 11px 0;border-radius: 3px;
    }
    button.clear{
      background-color: @attendance-background-color-7;
      color: @attendance-background-color-1;
    }
    button.confirm{
      background-color: @attendance-background-color-1;
      color: @attendance-color-3;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/teacher/Attendance/attendanceDetail.vue